export default "__VITE_PUBLIC_ASSET__61b2d265__"